module.exports = __webpack_public_path__ + "img/IMG_6070_L_Black.1921be97.jpg";